import { useMemo } from 'react';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { FormProvider } from 'core/states';
import { INote } from 'core/types';
import { IQuotePartNoteForm } from 'quotes/types';

import { editNoteSchema } from './schema';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  note: INote;
  onSubmit: (data: INote) => Promise<{ success: boolean }>;
  level?: number;
}

export const EditNote = ({ isOpen = false, onClose, note, onSubmit, level = 0 }: IProps) => {
  const { t } = useTranslation();

  const defaultValues = useMemo(() => ({ content: note?.content }), [note.content]);

  const handleOnSubmit = () => async (data: INote) => {
    const { success } = await onSubmit({ ...note, ...data });

    if (success) {
      setTimeout(() => onClose(), 1000);
    }
  };

  const handleOnClose = (reset?: UseFormReset<IQuotePartNoteForm>) => {
    reset();
    onClose();
  };

  return (
    <FormProvider schema={editNoteSchema()} defaultValues={defaultValues} resetDefaultValues>
      <Form
        title={t('titleEditNote')}
        isOpen={isOpen}
        onClose={handleOnClose}
        onSubmit={handleOnSubmit}
        level={level}
      >
        <FormField
          name="content"
          type={InputType.TEXT_EDITOR}
          inputProps={{ maxLength: note.maxLength }}
        />
      </Form>
    </FormProvider>
  );
};
